import type { Address } from "@medplum/fhirtypes";

/** Canonical US postal address input. State is the two-letter code. */
export interface PostalAddressInput {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  stateTwoLetter: string;
  zipCode: string;
}

/** Converts a `PostalAddressInput` to a FHIR `Address`. Empty lines are dropped. */
export function toFhirPostalAddress(input: PostalAddressInput): Address {
  return {
    line: [input.addressLine1, input.addressLine2].filter(Boolean) as string[],
    city: input.city,
    state: input.stateTwoLetter,
    postalCode: input.zipCode,
  };
}
